import React from "react";
import { Link } from "react-router-dom";

/*
  NotFoundPage 组件用于显示 404 错误页面，
  当用户访问不存在的页面时，显示一个简单的错误提示和返回首页的链接。
*/
const NotFoundPage = () => (
  // 使用 <main> 标签作为页面的主要内容区域，
  // 并通过 Tailwind CSS 类设置居中布局、间距、高度和背景颜色。
  <main className="flex flex-col items-center justify-center gap-4 h-screen bg-gray-100">
    {/* 显示 404 错误提示，使用较大字体和粗体样式 */}
    <h1 className="text-5xl font-bold text-gray-800">404 Not Found</h1>
    {/* 提供返回首页的链接，带有下划线悬停效果 */}
    <Link to="/" className="text-xl text-blue-500 hover:underline">
      Back to Home
    </Link>
  </main>
);

export default NotFoundPage;